function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5004 0H15.667V7.85049H23.5004V0Z",
  fill: "#4169E1"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.6664 0H7.83301V7.85049H15.6664V0Z",
  fill: "#4169E1"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.83337 0L3.91668 3.92525L1.95834 5.88787L0 7.85049H7.83337V0Z",
  fill: "#4169E1"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.6664 16.1494H7.83301V23.9999H15.6664V16.1494Z",
  fill: "#4FD1C5"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5004 11.6636H15.667V16.1496H23.5004V11.6636Z",
  fill: "#4FD1C5"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M7.83337 7.85059H0V11.6637H7.83337V7.85059Z",
  fill: "#4169E1"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M7.83337 16.1494H0V23.9999H7.83337V16.1494Z",
  fill: "#4FD1C5"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5004 16.1494H15.667V23.9999L19.5837 20.0747L23.5004 16.1494Z",
  fill: "#4FD1C5"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M190.386 20.2502V3.4502H192.978V17.8982H201.066V20.2502H190.386Z",
  fill: "#4FD1C5"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M176.979 20.2502V3.4502H187.564V5.8022H179.571V10.6262H186.892V12.9782H179.571V17.8982H187.684V20.2502H176.979Z",
  fill: "#4FD1C5"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M166.878 20.2502V5.8022H161.718V3.4502H174.63V5.8022H169.47V20.2502H166.878Z",
  fill: "#4FD1C5"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M146.862 20.2502V3.4502H151.854L156.414 18.5222H156.798V3.4502H159.366V20.2502H154.374L149.814 5.1542H149.43V20.2502H146.862Z",
  fill: "#4FD1C5"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M140.769 20.2502V3.4502H143.361V20.2502H140.769Z",
  fill: "#4FD1C5"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M130.667 20.2502V5.8022H125.507V3.4502H138.419V5.8022H133.259V20.2502H130.667Z",
  fill: "#F4EFEA"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M111.752 20.2502V3.4502H118.808C119.848 3.4502 120.76 3.6342 121.544 4.0022C122.344 4.3542 122.96 4.8662 123.392 5.5382C123.84 6.2102 124.065 7.01021 124.065 7.93821V8.20221C124.065 9.25821 123.808 10.1062 123.296 10.7462C122.8 11.3702 122.192 11.8102 121.472 12.0662V12.4502C122.08 12.4822 122.568 12.6902 122.936 13.0742C123.304 13.4422 123.488 13.9782 123.488 14.6822V20.2502H120.872V15.0422C120.872 14.6102 120.76 14.2662 120.536 14.0102C120.312 13.7542 119.952 13.6262 119.456 13.6262H114.344V20.2502H111.752ZM114.344 11.2742H118.52C119.448 11.2742 120.168 11.0422 120.68 10.5782C121.192 10.0982 121.448 9.45021 121.448 8.63421V8.44221C121.448 7.62621 121.192 6.98621 120.68 6.52221C120.184 6.0422 119.464 5.8022 118.52 5.8022H114.344V11.2742Z",
  fill: "#F4EFEA"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M101.916 20.5863C99.8519 20.5863 98.2119 20.0103 96.9959 18.8583C95.7799 17.6903 95.1719 16.0103 95.1719 13.8183V9.88228C95.1719 7.69027 95.7799 6.01827 96.9959 4.86626C98.2119 3.69826 99.8519 3.11426 101.916 3.11426C103.98 3.11426 105.62 3.69826 106.836 4.86626C108.068 6.01827 108.684 7.69027 108.684 9.88228V13.8183C108.684 16.0103 108.068 17.6903 106.836 18.8583C105.62 20.0103 103.98 20.5863 101.916 20.5863ZM101.916 18.2583C103.244 18.2583 104.268 17.8743 104.988 17.1063C105.708 16.3223 106.068 15.2583 106.068 13.9143V9.78628C106.068 8.44228 105.708 7.38627 104.988 6.61827C104.268 5.83427 103.244 5.44227 101.916 5.44227C100.62 5.44227 99.6039 5.83427 98.8679 6.61827C98.1319 7.38627 97.7639 8.44228 97.7639 9.78628V13.9143C97.7639 15.2583 98.1319 16.3223 98.8679 17.1063C99.6039 17.8743 100.62 18.2583 101.916 18.2583Z",
  fill: "#F4EFEA"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M81.1431 20.2502V3.4502H87.8151C88.8391 3.4502 89.7511 3.6582 90.5511 4.0742C91.3671 4.4742 91.9991 5.0502 92.4471 5.8022C92.9111 6.53821 93.1431 7.42621 93.1431 8.46621V8.77821C93.1431 9.81822 92.9031 10.7142 92.4231 11.4662C91.9591 12.2182 91.3271 12.7942 90.5271 13.1942C89.7271 13.5942 88.8231 13.7942 87.8151 13.7942H83.7351V20.2502H81.1431ZM83.7351 11.4422H87.5511C88.4631 11.4422 89.1911 11.2022 89.7351 10.7222C90.2791 10.2422 90.5511 9.58622 90.5511 8.75421V8.51421C90.5511 7.66621 90.2791 7.00221 89.7351 6.52221C89.1911 6.0422 88.4631 5.8022 87.5511 5.8022H83.7351V11.4422Z",
  fill: "#F4EFEA"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M66.6821 20.2502V3.4502H73.3542C74.3782 3.4502 75.2902 3.6582 76.0902 4.0742C76.9062 4.4742 77.5382 5.0502 77.9862 5.8022C78.4502 6.53821 78.6822 7.42621 78.6822 8.46621V8.77821C78.6822 9.81822 78.4422 10.7142 77.9622 11.4662C77.4982 12.2182 76.8662 12.7942 76.0662 13.1942C75.2662 13.5942 74.3622 13.7942 73.3542 13.7942H69.2741V20.2502H66.6821ZM69.2741 11.4422H73.0902C74.0022 11.4422 74.7302 11.2022 75.2742 10.7222C75.8182 10.2422 76.0902 9.58622 76.0902 8.75421V8.51421C76.0902 7.66621 75.8182 7.00221 75.2742 6.52221C74.7302 6.0422 74.0022 5.8022 73.0902 5.8022H69.2741V11.4422Z",
  fill: "#F4EFEA"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M56.9154 20.5863C55.5873 20.5863 54.4433 20.3462 53.4833 19.8662C52.5393 19.3862 51.8033 18.6982 51.2753 17.8022C50.7633 16.8902 50.5073 15.7862 50.5073 14.4902V3.4502H53.1233V14.5622C53.1233 15.7462 53.4513 16.6582 54.1073 17.2982C54.7633 17.9382 55.6993 18.2582 56.9154 18.2582C58.1314 18.2582 59.0674 17.9382 59.7234 17.2982C60.3794 16.6582 60.7074 15.7462 60.7074 14.5622V3.4502H63.2994V14.4902C63.2994 15.7862 63.0434 16.8902 62.5314 17.8022C62.0194 18.6982 61.2834 19.3862 60.3234 19.8662C59.3634 20.3462 58.2274 20.5863 56.9154 20.5863Z",
  fill: "#F4EFEA"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M41.7144 20.5863C40.4504 20.5863 39.3304 20.3623 38.3544 19.9143C37.3784 19.4663 36.6104 18.8103 36.0504 17.9463C35.5064 17.0663 35.2344 16.0023 35.2344 14.7543V14.1543H37.8024V14.7543C37.8024 15.9383 38.1544 16.8263 38.8584 17.4183C39.5784 18.0103 40.5304 18.3063 41.7144 18.3063C42.9144 18.3063 43.8184 18.0583 44.4264 17.5623C45.0344 17.0503 45.3384 16.3943 45.3384 15.5943C45.3384 15.0663 45.1944 14.6343 44.9064 14.2983C44.6184 13.9623 44.2104 13.6983 43.6824 13.5063C43.1544 13.2983 42.5224 13.1063 41.7864 12.9303L40.8984 12.7143C39.8264 12.4583 38.8904 12.1463 38.0904 11.7783C37.3064 11.3943 36.6984 10.8903 36.2664 10.2663C35.8344 9.64228 35.6184 8.84228 35.6184 7.86627C35.6184 6.87427 35.8584 6.02627 36.3384 5.32227C36.8344 4.61826 37.5144 4.07426 38.3784 3.69026C39.2424 3.30626 40.2584 3.11426 41.4264 3.11426C42.5944 3.11426 43.6344 3.31426 44.5464 3.71426C45.4744 4.11426 46.2024 4.70626 46.7304 5.49027C47.2584 6.27427 47.5224 7.25827 47.5224 8.44228V9.30628H44.9544V8.44228C44.9544 7.72227 44.8024 7.13827 44.4984 6.69027C44.2104 6.24227 43.8024 5.91427 43.2744 5.70627C42.7464 5.49827 42.1304 5.39427 41.4264 5.39427C40.4024 5.39427 39.6024 5.61027 39.0264 6.04227C38.4664 6.45827 38.1864 7.04227 38.1864 7.79427C38.1864 8.30627 38.3064 8.73028 38.5464 9.06628C38.8024 9.38628 39.1704 9.65028 39.6504 9.85828C40.1304 10.0663 40.7304 10.2503 41.4504 10.4103L42.3384 10.6263C43.4264 10.8663 44.3864 11.1783 45.2184 11.5623C46.0504 11.9303 46.7064 12.4343 47.1864 13.0743C47.6664 13.7143 47.9064 14.5383 47.9064 15.5463C47.9064 16.5543 47.6504 17.4343 47.1384 18.1863C46.6424 18.9383 45.9304 19.5303 45.0024 19.9623C44.0744 20.3783 42.9784 20.5863 41.7144 20.5863Z",
  fill: "#F4EFEA"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 24,
    viewBox: "0 0 202 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.a984be38.svg";
export { ForwardRef as ReactComponent };